import SignupWizard from '../components/signup/SignupWizard';

export default function SignupPage() {
  return <SignupWizard />;
}